module.exports = __webpack_public_path__ + "img/play.54cea9b0.png";